import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface UserLegalConsentStatusDto {
  termsAndConditionsAccepted: boolean;
  termsAndConditionsAcceptedAt?: string;
  termsAndConditionsVersion: string;
  privacyPolicyAccepted: boolean;
  privacyPolicyAcceptedAt?: string;
  privacyPolicyVersion: string;
}

export interface UserLegalConsentAcceptDto {
  version?: string;
}

@Injectable({ providedIn: 'root' })
export class LegalConsentService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = '/api/users/me/legal-consent';

  getMyStatus(): Observable<UserLegalConsentStatusDto> {
    return this.http.get<UserLegalConsentStatusDto>(this.apiUrl);
  }

  acceptTerms(dto?: UserLegalConsentAcceptDto): Observable<UserLegalConsentStatusDto> {
    return this.http.post<UserLegalConsentStatusDto>(`${this.apiUrl}/terms/accept`, dto ?? {});
  }

  acceptPrivacy(dto?: UserLegalConsentAcceptDto): Observable<UserLegalConsentStatusDto> {
    return this.http.post<UserLegalConsentStatusDto>(`${this.apiUrl}/privacy/accept`, dto ?? {});
  }
}
